/** Normalize profilePic from API / auth payloads to a display URL. */
export function getProfilePicUrl(profilePic: unknown): string | null {
  if (!profilePic) return null;
  if (typeof profilePic === 'string') {
    const value = profilePic.trim();
    return value || null;
  }
  if (typeof profilePic === 'object') {
    const url = (profilePic as { url?: unknown }).url;
    if (typeof url === 'string' && url.trim()) return url.trim();
  }
  return null;
}
